var t={},e={};function n(t){return["BUTTON","INPUT"].indexOf(t.tagName)>-1||parseInt(t.getAttribute("tabindex"),10)>-1}export{e as inputLabels,t as inputs,n as isTabbable};
//# sourceMappingURL=utils.js.map
